import { render, staticRenderFns } from "./SaleReturn.vue?vue&type=template&id=4ee9b124&scoped=true"
import script from "./SaleReturn.vue?vue&type=script&lang=js"
export * from "./SaleReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee9b124",
  null
  
)

export default component.exports